export const PREFIX_VALIDATOR = {
    name: 'regexp',
    condition: /^(3[0-2]|[12][0-9]|[1-9])$/,
    message: 'Prefix must be from 1 to 32 only',
};
